import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import { Row, Col } from 'antd';
import { AppstoreFilled } from '@ant-design/icons';
import Cards from 'components/Cards/Cards';

const ReviewCardsSection = ({ background, menuText, title, sections, ...otherProps }) => (
  <SectionContainer background={background} {...otherProps}>
    <div className="section-review-card--container">
      <h2 className="section-review-card--title">{title}</h2>
      <MenuArea>
        <AppstoreFilled />
        <span>{menuText}</span>
        <Link to="/reviews">All</Link>
      </MenuArea>
      {sections?.map((section, index) => {
        return section.type === 'icon' ? (
          <IconCardSection section={section} key={index} />
        ) : (
          <VideoCardSection section={section} key={index} />
        );
      })}
    </div>
  </SectionContainer>
);

const IconCardSection = ({ section }) => (
  <div className="section-review-card--card-container">
    {section.cards.map(review => (
      <div className="section-review-card--card-item" key={review.id}>
        <Cards
          bodyType={'review'}
          companyLogo={review?.companyLogo}
          quote={review?.quote?.quote}
          author={review.author}
          company={review.companyPosition}
        />
      </div>
    ))}
  </div>
);

const VideoCardSection = ({ section }) => {
  const card = section.cards;
  return (
    <div className="section-review-card--card-container">
      <div className="section-review-card--card-item">
        <Cards
          type={'Video'}
          bodyType={'review'}
          sideCover={true}
          sideReverse={section.reverse}
          coverVideo={card.wistiaVideo}
          companyLogo={card.companyLogo}
          quote={card.quote?.quote}
          author={card.author}
          company={card.companyPosition}
        />
      </div>
    </div>
  );
};

const SectionContainer = styled.div`
  background: ${props => props.background};

  .section-review-card--container {
    margin: 0 auto;
    padding: 133px 21px 91px;
    max-width: 1200px;

    .section-review-card--title {
      font-size: 49px;
      font-weight: 900;
      line-height: 110%;
      text-align: center;
      letter-spacing: -0.04em;
      color: var(--neutral-7);
      max-width: 784px;
      margin: 0 auto;
    }

    .section-review-card--card-container {
      display: flex;
      margin: 30px -20px 0;

      .section-review-card--card-item {
        flex: 1;
        margin: 0 20px;
        max-width: calc(100% - 40px);
      }
    }
  }

  @media (max-width: 991px) {
    .section-review-card--container {
      .section-review-card--card-container {
        margin: 0 -10px;

        .section-review-card--card-item {
          margin: 12px 10px;
          max-width: calc(100% - 20px);
        }
      }
    }
  }

  @media (max-width: 768px) {
    .section-review-card--container {
      margin: 0 auto;
      padding: 50px 28px 82px;

      .section-review-card--title {
        font-size: 36px;
        line-height: 44px;
      }

      .section-review-card--card-container {
        flex-wrap: wrap;

        .section-review-card--card-item {
          flex: auto;
          width: calc(50% - 20px);
        }
      }
    }
  }

  @media (max-width: 576px) {
    .section-review-card--container {
      margin: 0 auto;
      padding: 55px 20px 66px;

      .section-review-card--title {
        font-size: 32px;
        line-height: 36px;
      }

      .section-review-card--card-container {
        .section-review-card--card-item {
          width: 100%;
        }
      }
    }
  }
`;

const MenuArea = styled.div`
  max-width: fit-content;
  color: var(--neutral-text-color);
  margin: 50px auto;
  font-size: 16px;
  span {
    margin: 0 14px 0 7px;
  }
`;

export default ReviewCardsSection;
